// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";

const getEventPropertyName = (event: any) => {
    if (typeof event === "string") {
        switch (event) {
            case "page_view":
                return "page";
            case "search_filtered":
                return "filters";
        }
    }

    return ga.defaultPropertyName;
};

export default getEventPropertyName;
